<template>
  <section class="p-webmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">WEB应用性能监控系统</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">MonitorWay WEB应用性能监控系统可以测试内部和面向客户的应用程序的用户体验。 快速排除与网站元素相关的 Web 应用程序延迟故障，
            其中包括 CSS、HTML、图片、JavaScript®等，并确定影响 Web 应用程序性能的基础架构资源（如 Web 服务器、数据库等）。</p>
          <img src="../../assets/monitor/web.jpg" class="c-cs-p" preview="monitor-web"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay WEB应用性能监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-136 c-p-r">
            <ul>
              <li>在线实时监测WEB应用的性能</li>
              <li>监测指标包括下载速度、访问的延时等指标</li>
              <li>支持分布式多站点采集的方式</li>
            </ul>
            <img src="../../assets/monitor/web-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/web1.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">网站和 Web 应用程序性能报告</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">基于 Web 的报告可实现轻松生成关于页面加载速度、事务健康情况、网站可用性和其他关键性能指标的快速报告。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/config3.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">使用详细的加载时间指标进行故障排除</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">使用TCP瀑布图快速确定加载时间最长的页面元素。 监控诸如 HTML、CSS、JavaScript、图片之类的网站元素及其整体性能和加载指标。
                  如果图片不匹配以及存在影响应用程序性能的不完整或缓慢事务时，发出通知。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip8.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">分权分级管理</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">通过角色与权限的设置，可以实现机构和用户的独立管理的功能。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip3.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">直观的面板</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">基于 Web 的面板有助于您快速深入了解 Web 应用程序问题的根本原因。
                </p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet8.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">多站点采集</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay WEB应用性能监控系统的多站点采集代理部署非常灵活，可以部署在任意的位置，进行WEB应用的监测。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">故障预警</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay WEB应用性能监控系统可通过阈值设置的方式，发现指标性能超过设置阀值，可以触发告警通知。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">WEB应用性能监控系统</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">MonitorWay WEB应用性能监控系统可以测试内部和面向客户的应用程序的用户体验。 快速排除与网站元素相关的 Web 应用程序延迟故障，
            其中包括 CSS、HTML、图片、JavaScript®等，并确定影响 Web 应用程序性能的基础架构资源（如 Web 服务器、数据库等）。</p>
          <img src="../../assets/monitor/web.jpg" preview="monitor-web1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay WEB应用性能监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>在线实时监测WEB应用的性能</li>
              <li>监测指标包括下载速度、访问的延时等指标</li>
              <li>支持分布式多站点采集的方式</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <swiper class="swiper" :options="swiperOption" ref="mySwiper">
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/web1.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">网站和 Web 应用程序性能报告</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">基于 Web 的报告可实现轻松生成关于页面加载速度、事务健康情况、网站可用性和其他关键性能指标的快速报告。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip4.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">故障预警</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay WEB应用性能监控系统可通过阈值设置的方式，发现指标性能超过设置阀值，可以触发告警通知。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip8.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">分权分级管理</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">通过角色与权限的设置，可以实现机构和用户的独立管理的功能。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip3.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">直观的面板</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">基于 Web 的面板有助于您快速深入了解 Web 应用程序问题的根本原因</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet8.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">多站点采集</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay WEB应用性能监控系统的多站点采集代理部署非常灵活，可以部署在任意的位置，进行WEB应用的监测。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/config3.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">使用详细的加载时间指标进行故障排除</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">使用TCP瀑布图快速确定加载时间最长的页面元素。 监控诸如 HTML、CSS、JavaScript、图片之类的网站元素及其整体性能和加载指标。
                        如果图片不匹配以及存在影响应用程序性能的不完整或缓慢事务时，发出通知。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination1" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'web',
  data () {
    return {
      swiperOption: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination1',
          clickable: true
        }
      }
    }
  }
}
</script>

<style lang="scss">
.p-webmonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -100px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
    .swiper {
      width: 100%;
      --swiper-theme-color: #FF8243;
      .swiper-pagination, .swiper-pagination-bullets {
        bottom: 15px;
        .swiper-pagination-bullet {
          width: 20px;
          height: 3px;
          border-radius: 1.5px;
          margin: 0 4px;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          width: 50px;
        }
      }
    }
  }
}
</style>
